import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { ScanPartnerCodeInfo } from '../../partner-code/models/scan-partner-code-info';
import { PartnerCodeService } from '../../partner-code/services/partner-code.service';
import { PartnerStateService } from '../../partner/services/partner-state.service';
import { ScanCard } from '../../vu/models/scan-card';

@Injectable()
export class RefundCardPartnerService {

  constructor(
    private partnerCodeService: PartnerCodeService,
    private partnerStateService: PartnerStateService,
  ) {
  }

  get cardBalance(): Observable<number> {
    return this.partnerStateService.initialize().pipe(
      map(partner => partner ? partner.accountBalance : 0),
    );
  }

  getPartnerInfo(cardUID: string): Observable<ScanPartnerCodeInfo> {
    return this.partnerCodeService.getPartnerInfo(ScanCard.createFromCardCode(cardUID));
  }

}
